import React from "react"
import { Grid, Typography} from "@material-ui/core"
import { ControlledDatePicker } from "../../../Core/Form/Datepickers";
import SkywatchInformationTooltip from "../../../Core/Popover/SkywatchInformationTooltip";
import PhysicalDamageSelect from "./PhysicalDamageSelect";
import { QuoteContextStore } from '../../../../context/QuoteContext/QuoteContext';
import LiabiltyCoverageSelect from "./LiabiltyCoverageSelect";
import DesktopOnlyText from "../../../Core/Text/DesktopOnlyText";
import { useContext } from "react"
import StartTimeDatePicker from "./StartTimeDatePicker";


const LiabilitySection = () => {
    const { aircrafts } = useContext(QuoteContextStore);
    const { value : aircraftValue,locked_quote} = aircrafts[Object.keys(aircrafts)[0]];

    return (
    <Grid container md={12}>
        <Grid container justifyContent="space-between" alignItems="center" className="margin-bottom-large" spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={7}>
                <SkywatchInformationTooltip 
                    subtext="When would you like your insurance to start?" 
                    text="Coverage with effect from 12:01 AM local time at address of insured" placement="right">
                    <Typography variant="h3" className="blue">Starting date</Typography>
                </SkywatchInformationTooltip>
                <DesktopOnlyText variant="body1" className="margin-top-6">When would you like your insurance<br />to start?</DesktopOnlyText>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={5}>
                <StartTimeDatePicker />
            </Grid>
        </Grid>
        <Grid container justifyContent="space-between" alignItems="center" className="margin-bottom-large" spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={7}>
                <SkywatchInformationTooltip 
                    subtext="Insurance limit that applies to bodily injury and property damage liability" 
                    text="This coverage is for bodily injury and property damage arising out of an occurrence for which the insured becomes legally obligated to pay arising out of the ownership, maintenance, or use of the insured aircraft or premises upon which the aircraft is stored" placement="right">
                    <Typography variant="h3" className="blue">Liability insurance</Typography>
                </SkywatchInformationTooltip>
                <DesktopOnlyText variant="body1" className="margin-top-6">Insurance limit that applies to bodily injury<br />and property damage liability</DesktopOnlyText>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={5}>
                <LiabiltyCoverageSelect />
            </Grid>
        </Grid>
        <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={7}>
                <SkywatchInformationTooltip 
                    subtext={`Please select your coverage limit. Insured Value: $${aircraftValue ? aircraftValue.toLocaleString('en-US') : 0}`}
                    text="This is designed to pay for physical damage to the aircraft described below, while in-flight or not in-flight, including disappearances thereof. Please contact us if not-in-flight Physical Damage Coverage options are desired." placement="right">
                    <Typography variant="h3" className="blue">Physical damage</Typography>
                </SkywatchInformationTooltip>
                <DesktopOnlyText variant="body1" className="margin-top-6">Please select your coverage limit.<br /> <span className="bold black">Insured Value: ${ aircraftValue ? aircraftValue.toLocaleString('en-US') : 0}</span></DesktopOnlyText>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={5}>
                <PhysicalDamageSelect />
            </Grid>
        </Grid>
    </Grid>
    )
}

export default LiabilitySection